export default "__VITE_ASSET__y7tZRuzF__"